// Custom Redirect Mapping Generated from CSV

const redirects = {
  "/collections/50-75/madrid": "/collections/50-75/",
  "/collections/all/color-rose": "/collections/all/",
  "/collections/birkenstock-classic/size-34": "/collections/birkenstock-classic/",
  "/collections/birkenstock-kids/new": "/collections/birkenstock-kids/",
  "/collections/birkenstock-seasonal/ecru": "/collections/birkenstock-seasonal/",
  "/collections/birkenstock-seasonal/sandcastle": "/collections/birkenstock-seasonal/",
  "/collections/birkenstock-shoes/sa": "/collections/birkenstock-shoes/",
  "/collections/clogs/shoe-store-hahndorf": "/collections/clogs/",
  "/collections/collection/featured": "/collections/",
  "/collections/collection/l18": "/collections/",
  "/collections/color-big-ben-golden-brown/keen": "/collections/",
  "/collections/color-big-ben-golden-brown": "/collections/",
  "/collections/color-black/eva": "/collections/color-black/",
  "/collections/color-black-mesh/shoes": "/collections/",
  "/collections/color-black-mesh": "/collections/",
  "/collections/color-brown-python": "/collections/color-brown/",
  "/collections/color-cuoio/sole-drifter": "/collections/color-cuoio/",
  "/collections/color-dark-red-coral/zippay": "/collections/color-dark-red-coral/",
  "/collections/color-dusty-olive-nostalgia-rose/paypal": "/collections/color-dusty-olive-nostalgia-rose/",
  "/collections/color-dusty-olive-nostalgia-rose": "/collections/color-dusty-olive-nostalgia-rose/",
  "/collections/color-espresso/birkenstock-in-the-hills": "/collections/color-espresso/",
  "/collections/color-espresso/comfort-shoes-adelaide": "/collections/color-espresso/",
  "/collections/color-gibraltar-fudgesi/laybuy": "/collections/color-gibraltar-fudgesi/",
  "/collections/color-gold/birkenstock-brisbane": "/collections/color-gold/",
  "/collections/color-gold/women": "/collections/color-gold/",
  "/collections/color-gold-leaf": "/collections/color-gold/",
  "/collections/color-jeans-melange/shoe-shop-adelaide": "/collections/color-jeans-melange/",
  "/collections/color-khaki/mens-shoes": "/collections/color-khaki/",
  "/collections/color-khaki": "/collections/color-khaki/",
  "/collections/color-mushroom/leather": "/collections/color-mushroom/",
  "/collections/color-mushroom": "/collections/color-mushroom/",
  "/collections/color-navy/sydney": "/collections/color-navy/",
  "/collections/color-navy": "/collections/color-navy/",
  "/collections/color-oily-coal-combo/shoe-stores-in-adelaide": "/collections/color-oily-coal-combo/",
  "/collections/color-purple-fog/adelaide-shoe-store": "/collections/color-purple-fog/",
  "/collections/color-purple-fog/felted-wool": "/collections/color-purple-fog/",
  "/collections/color-purple-fog/footwear-adelaide": "/collections/color-purple-fog/",
  "/collections/color-red-plaid": "/collections/color-red/",
  "/collections/color-saddle-brown-combo/women": "/collections/color-saddle-brown-combo/",
  "/collections/color-sand/birkenstock-melbourne": "/collections/color-sand/",
  "/collections/color-sepia-black/size-12uk": "/collections/color-sepia-black/",
  "/collections/color-shearling-black/birkenstocks-adelaide": "/collections/color-shearling-black/",
  "/collections/josef-seibel/size-50": "/collections/josef-seibel/",
  "/collections/medical/kay": "/collections/medical/",
  "/collections/meindl/best": "/collections/meindl/",
  "/collections/mens-clogs/shearling": "/collections/mens-clogs/",
  "/collections/mongrel-socks/white": "/collections/mongrel-socks/",
  "/collections/plunkett-leg-care-cream/all": "/collections/",
  "/collections/rieker-antistress/fit-regular": "/collections/rieker-antistress/",
  "/collections/rieker-antistress": "/collections/rieker-antistress/",
  "/collections/sandals/color-vintage-fog": "/collections/sandals/",
  "/collections/sandals/size-adult-8-aus-womens-10": "/collections/sandals/",
  "/collections/size-11-5/removable-footbed": "/collections/size-11-5/",
  "/collections/size-11uk/adelaide-shoes": "/collections/size-11uk/",
  "/collections/size-26/afterpay": "/collections/size-26/",
  "/collections/size-27/birkenstock-perth": "/collections/size-27/",
  "/collections/size-37/color-stardust": "/collections/size-37/",
  "/collections/size-37/eva": "/collections/size-37/",
  "/collections/size-37/waterproof": "/collections/size-37/",
  "/collections/size-38/birkenstock-super-grip": "/collections/size-38/",
  "/collections/size-38/naot-australia": "/collections/size-38/",
  "/collections/size-38/vegan": "/collections/size-38/",
  "/collections/size-39/josef-seibel": "/collections/size-39/",
  "/collections/size-41/slipp-on": "/collections/size-41/",
  "/collections/size-5/birkenstock-in-the-hills": "/collections/size-5/",
  "/collections/size-6/best": "/collections/size-6/",
  "/collections/size-c13/size-c10": "/collections/size-c13/",
  "/collections/size-infant-8/color-brown": "/collections/size-infant-8/",
  "/collections/size-m12/adelaide-shoe-shops": "/collections/size-m12/",
  "/collections/size-m9-w11/size-w3": "/collections/size-m9-w11/",
  "/collections/size-w7/warden": "/collections/size-w7/",
  "/collections/vegan/cruelty-free": "/collections/vegan/",
  "/collections/wolky/new": "/collections/wolky/",
  "/collections/womens-clogs/light-blue": "/collections/womens-clogs/",
  "/collections/womens-shoes/zip": "/collections/womens-shoes/",
  "/collections/womens-thongs/humm": "/collections/womens-thongs/"
};

const path = window.location.pathname;

if (redirects[path]) {
  window.location.href = redirects[path];
}
